import Vue from 'vue';
import Router from 'vue-router';
import cf4 from './components/CF4Components/index';
import CF4ListPage from "./components/page/CF4ListPage";
import Login from './components/auth/Login'
import Dashboard from './components/dashboard/Dashboard'
import SureclaimsList from './components/sureclaims/List';
import SureclaimsCreate from './components/sureclaims/Create';

Vue.use(Router);

let router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/login',
            name: 'Login',
            component: Login,
            meta: {
                layout: 'no-sidebar'
            }
        },
        {
            path: '/',
            name: 'Dashboard',
            component: Dashboard,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/generate',
            name: 'CF4',
            component: cf4,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/list',
            name: 'List of CF4 Records',
            component: CF4ListPage,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/edit/:pid',
            name: 'Edit CF4',
            component: cf4,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/sureclaims/cf4/list',
            name: 'Sureclaims Patients',
            component: SureclaimsList,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/sureclaims/cf4/create/',
            name: 'Create CF4',
            component: SureclaimsCreate,
            meta: {
                requiresAuth: true,
            },
        },
    ],
});

router.beforeEach((to, from, next) => {
    let authenticated = localStorage.getItem('AUTH_TOKEN');
    if (to.meta.requiresAuth) {
        if (!authenticated) {
            return next({
                path: '/login',
            });
        }
    }
    if (to.path === '/login' && authenticated) {
        return next({
            path: '/list',
        });
    }
    return next();
});
export default router;
